var render = function render(){var _vm=this,_c=_vm._self._c;return _c('meter-record-crud',{attrs:{"allowed-fee-types":[2, 4],"page-title":"水·污水 — 抄表明细台账","direct-usage-entry":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }